import { computed, reactive } from 'vue'
import axios from 'axios'

const bannersState = reactive({
  result: {
    items: []
  },
  loading: false,
  loaded: false
})

const BANNER_CACHE_TTL_MS = 10 * 60 * 1000
let bannersCache = {
  value: [],
  expiresAt: 0
}

const normalizeBanners = (items) => {
  if (!Array.isArray(items)) {
    return []
  }

  return items
    .filter((item) => item && item.active)
    .sort((a, b) => {
      const aSort = Number.isFinite(Number(a.sort)) ? Number(a.sort) : Number.MAX_SAFE_INTEGER
      const bSort = Number.isFinite(Number(b.sort)) ? Number(b.sort) : Number.MAX_SAFE_INTEGER

      if (aSort !== bSort) {
        return aSort - bSort
      }

      return String(a.id || '').localeCompare(String(b.id || ''))
    })
}

const getBannerImageUrl = (item) => {
  if (!item || !item.image) {
    return '/img/banners/ps-banner-1.jpg'
  }

  const image = String(item.image)
  if (image.indexOf('http') === 0) {
    return image
  }

  return `${process.env.VUE_APP_BLOB_CONTAINER}/images/banners/${image}`
}

export function useBanners () {
  const searchBanners = async () => {
    const now = Date.now()
    if (bannersCache.expiresAt > now) {
      bannersState.result.items = bannersCache.value
      bannersState.loading = false
      bannersState.loaded = true
      return
    }

    if (bannersState.loading) {
      return
    }

    bannersState.loading = true

    try {
      const response = await axios.get('pub/banners')
      const items = normalizeBanners(response?.data?.result?.items)

      bannersCache = {
        value: items,
        expiresAt: now + BANNER_CACHE_TTL_MS
      }

      bannersState.result.items = items
    } catch (error) {
      bannersState.result.items = []
      bannersCache = {
        value: [],
        expiresAt: now + 30 * 1000
      }
    } finally {
      bannersState.loading = false
      bannersState.loaded = true
    }
  }

  const featuredBanners = computed(() => {
    return bannersState.result.items
  })

  const getBannerImage = computed(() => {
    return (item) => `url("${getBannerImageUrl(item)}")`
  })

  return {
    bannersState,
    searchBanners,
    featuredBanners,
    getBannerImage,
    getBannerImageUrl
  }
}
